import { render, staticRenderFns } from "./popoverView.vue?vue&type=template&id=145cc7c4"
import script from "./popoverView.vue?vue&type=script&lang=js"
export * from "./popoverView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports